import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import React ,{Component} from 'react';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningIcon from '@mui/icons-material/Warning';
import InputAdornment from '@mui/material/InputAdornment';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import CloseIcon from '@mui/icons-material/Close';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

export default class SalesTax extends Component {
constructor(props) {
    super(props);
	
	 this.state = {open:false,redirect: false,btndisabled:false,submitbtn:"Submit",
logredirect:false,pagename:'',pvdata:[],tx_name:'',tx_agency:'',percentage:'',newpcid:0,errormessage:'',erropen:false,errortype:'error',tx_visible:'',txid:0,iscombineddata:true,pagetitle:'New Tax Rate ',txmainid:0,
fromdate1:'',    RateArray:[],newRateArray:[],combineopne:true,combineclose:false,combinedata:[],newpercentage:'',

	}
   
}


	
	handleClickOpen = (e) => {
	
  this.setState({txid:this.props.txid,txmainid:this.props.txmainid,open:!this.state.open,
     errormessage:'',erropen:false,
	  },()=>{
		  
		  this.GetTaxMainData(this.props.txid);
		  
	  });

};


handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }

onclicktaxclose = (e) => {
	 this.setState({open:false});
	 
}


 GetTaxMainData(id) {
	
  if(this.props.txid!==0)
  {
	   axios.get(localStorage.getItem("ISIurl")+'ajaxtax.php?action=getall&tx_cmp_id='+localStorage.getItem("ISIcmpid")+'&tx_id='+id)
	  
  .then(resp => {  
		let oldOptionspvdata=[]; 
    if(resp.data.length>0){
		  oldOptionspvdata=resp.data
		
		let strvalue=false;
		let strtitle="";
	
		if(resp.data[0].tx_isvisible==="1")
		{
		
			strvalue=true;
		
		}
		
		
		if(resp.data[0].tx_mainid==="0")
		{
			strtitle="Combined Tax Rate";
			
		}
		else
		{
				strtitle="Edit  Tax Rate";
				
			
		}
    this.setState({ 
     
        txid:resp.data[0].tx_id,
		tx_name:resp.data[0].tx_name,
		tx_agency:resp.data[0].tx_agency,
	    percentage:resp.data[0].dwt_percentage,
	    tx_visible:strvalue,
	    pagetitle:strtitle,
		combineopne:false,
		
		
	    
	    
		
    });
	
  }

});
	 this.GETCombinedComponent(this.state.txid)
  }else{
	 this.setState({  
	txid:0
	  }); 
 }
  
    }

 GETCombinedComponent(id) {
	
  if(this.props.txid!==0)
  {
	   axios.get(localStorage.getItem("ISIurl")+'ajaxtax.php?action=getall&tx_cmp_id='+localStorage.getItem("ISIcmpid")+'&tx_id='+id+'&tx_mainid='+id)
	  
  .then(resp => {  
		let oldOptionspvdata=[]; 
    if(resp.data.length>0){
		  oldOptionspvdata=resp.data
		

	
    this.setState({ 
     
       combinedata:oldOptionspvdata,
      
       

		
    });
	
  }

});
	  
  }}

myChangeHandler = (event) => {

  let nam = event.target.name;
  let val = event.target.value;

	  
	   this.setState({[nam]: val});
  
 
  
}

  handleSubmit= (event) => {
	 event.preventDefault();
	 
	 let optionsVal=this.state.pvdata;

if(this.state.tx_name==="")
{
	this.setState({errormessage:"Please Enter  Name",erropen:true});
	return false;
}

if(this.state.percentage==="")
{
	this.setState({errormessage:"Please Enter percentage.",erropen:true});
	return false;
}

let optionValues="";
let sep1="";

   optionsVal.forEach(eachval => {
        if (eachval.tx_isdeleted === "0") {
			
			
            optionValues = optionValues + sep1 + eachval.tx_name + "~" + eachval.tx_agency + "~" + eachval.dwt_percentage;
            sep1 = "`";
        }
    });


this.setState({btndisabled:true,submitbtn:"Processing..."})
	 var formData = new FormData();

	  
	  let isivible="";
	  if(this.state.tx_visible===true)
	  {
		  isivible="1";
		  
	  }
	  else
	  {
		   isivible="0";
		  
	  }

	if(this.state.txid===0)
	{
		
	 formData.append('action','insert')
	 formData.append('dwt_percentage',this.state.percentage)
	 
	}
	else
		
		{
			
			formData.append('action','update')
			 formData.append('dwt_percentage',this.state.newpercentage)
			
		}
	 
	 
	 formData.append('tx_name',this.state.tx_name)
	 formData.append('tx_id',this.state.txid)
	 formData.append('dwt_fromdate',this.state.fromdate1)
	 formData.append('combinetaxvalues',optionValues)
	 
	 formData.append('tx_agency',this.state.tx_agency)
	 formData.append('tx_isvisible',isivible)
	 formData.append('tx_cmp_id',localStorage.getItem("ISIcmpid"))
	 formData.append('userid',localStorage.getItem("ISIuserid"))
	 
	
	 
    
	
	  
	 axios.post(localStorage.getItem("ISIurl")+"ajaxtax.php", formData, {
        }).then(res => {
			
			let strreturn=res.data;
			
			if(strreturn===1)
			{
				this.setState({errormessage:"Inserted succesfully",erropen:true,errortype:'success',percentage:'',tx_name:'',tx_agency:'',open:false,txid:0});
	          return false;
			   
				
			}
			
			
  
   });    
  };
 onRowdelete(rowindex){
	
  let r = window.confirm("Are you sure to Delete?");
		 if(r == true){
			const updatedArray = [...this.state.pvdata]; 
						
			 updatedArray[rowindex].tx_isdeleted = 1;	
			  this.setState({pvdata: updatedArray,});
			
		 }
	
	
}


  handleshowcheck=(e)=>{
	this.setState({tx_visible: !this.state.tx_visible},()=>{
		
		
	}); 
 }
  

myChangeHandlerPV = (index) => (event) => {
	
	
  const re = /^[0-9.\b]+$/;
  const nam = event.target.name;
  const val = event.target.value;

  const updatedArray = [...this.state.pvdata];

  if (nam === "tx_name") {
    updatedArray[index].tx_name = val;
  } else if (nam === "tx_agency") {
    updatedArray[index].tx_agency = val;
  } else if (nam === "dwt_percentage") {
    if (re.test(val)) { 
      updatedArray[index].dwt_percentage = val;
    } else {
      alert("Invalid input for dwt_percentage"); 
    }
  }

  this.setState({ pvdata: updatedArray }, () => {
   
      
	    let totalPercentage = 0; 

    this.state.pvdata.forEach((item) => {
      totalPercentage += parseFloat(item.dwt_percentage ); 
	  this.setState({percentage:totalPercentage});
    });
	  
   
  });
};


  
  
 AddcombinedComponent(){
	
	this.GetEmptyCombinecompoent();
	this.setState({combineclose:true,combineopne:false,});
	
}
 
  AddNewCombinecompoent (){
	let optionsRep=this.state.pvdata;

	 this.setState({pvdata:optionsRep.concat([{"tx_id":"","tx_name":"","tx_agency":"","dwt_percentage":"","tx_isdeleted":"0"}]), });
	  
	 
 }
 

   GetEmptyCombinecompoent() {
	 
	   this.setState({tx_agency:"Multiple",percentage:"0.0%",
	 pvdata: [{"tx_id":"","tx_name":"","tx_agency":"","dwt_percentage":"","tx_isdeleted":"0"}],}); 
 
 }



 GetEmptyCombinecompoentRateandDate = (index) =>{
	 
let optionsRep = this.state.newRateArray;
	
	
	  this.setState({newRateArray:optionsRep.concat([{"tx_id":"","fromdate":"","dwt_percentage":"","tx_isdeleted":"0"}]), });
	 
	 
 }

fromDataHandler = (date) => {
   var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }

    
    this.setState({
        fromdate: dayjs(dateObj),
       fromdate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
  
    
  
  
};






render() {
  if (this.state.logredirect === true) {
    return <Navigate to={this.state.pagename} />;
  }

  return (
    <React.Fragment>
	
	<div className="graybgpopup">
      <Dialog open={this.state.open} onClose={this.onclicktaxclose} maxWidth="md" fullWidth className="popup" aria-labelledby="form-dialog-title">
	  <b>
  <DialogTitle id="form-dialog-title">{this.state.pagetitle}</DialogTitle>
</b>

		
        <DialogContent>
         	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
            



	 <div className="salestaxdiv">
			 <ul>
			 <li>
				<p>Display Name <span className="validation">*</span></p>
                <p>
                  <TextField
                    name="tx_name"
                    onChange={this.myChangeHandler}
                    fullWidth
                    value={this.state.tx_name}
                    inputProps={{ tabIndex: "1", maxLength: 150 }}
                    className="txtbox"
                    InputLabelProps={{ shrink: true }}
                  />
                </p>
               </li>
			   
				 <li>
				
				<p>	Agency</p>
				 {this.state.txmainid !== "0" &&(
				 <React.Fragment>
                <p>
                 <TextField
				  name="tx_agency"
				  onChange={this.myChangeHandler}
				  fullWidth
				  value={this.state.tx_agency}
				  disabled={this.state.combineclose} 
				  inputProps={{ tabIndex: "1", maxLength: 150 }}
				  className="txtbox"
				  InputLabelProps={{ shrink: true }}
				/>
                </p>
				 	 </React.Fragment>)}
				 
				  {this.state.txmainid === "0" && (
					<p className="graytxtcolor">{this.state.tx_agency}</p>
				  )}
               </li>
			   <li>
				<p>	Percentage<span className="validation">*</span></p>
				 {this.state.txid == "0" &&(
				 <React.Fragment>
                <p>
              <TextField
				  name="percentage"
				  onChange={this.myChangeHandler}
				  fullWidth
				  value={this.state.percentage}  
				  inputProps={{ tabIndex: "3", maxLength: 150 }}
				  className="txtbox"
				  InputLabelProps={{ shrink: true }}
				  disabled={this.state.combineclose} 
				  InputProps={{
					startAdornment: this.state.combinedopen && (
					  <InputAdornment position="start">
						<WarningIcon style={{ color: "orange" }} titleAccess="Field is disabled" />
					  </InputAdornment>
					),
				  }}
				
					/>
					
				</p>
				
				 </React.Fragment> )}
				 
				 
				 {this.state.txid!==0 && (
					<p style={{textAlign:'center'}}className="graytxtcolor">{this.state.percentage}&nbsp;%</p>
				 )}
				 
               </li>
			   {this.state.txid===0 && (
			   <li><span className="percentagesymbol">%</span></li>
			   )}
				 
				 </ul>
			 
			 </div>
			 



			 {this.state.combineopne===true && (
  <p> <span className="greentextcolor" onClick={()=>{this.AddcombinedComponent()}}> Create a combined tax rate</span></p>
		 
			 )}
			 
			 
			 

			 {this.state.txid === 0 && (
 <div className="combinedtxtbox">
	<b>Components</b>		
	{this.state.pvdata.map((item, index) => (
  
<React.Fragment	  key={index}>
 
	{item.tx_isdeleted=== "0" &&  item.tx_mainid!=="0" &&(
      <ul>
     <li>  {this.state.txid === 0 && (
	  <DeleteIcon   onClick={()=>{this.onRowdelete(index)}}/> )}</li>
            
         <li>
            <p>
              <TextField
                name="tx_name"
                onChange={this.myChangeHandlerPV(index)}
                fullWidth
                value={item.tx_name}
                inputProps={{ tabIndex: "1", maxLength: 150 }}
                className="txtbox"
                InputLabelProps={{ shrink: true }}
              />
            </p>
          </li>
		  
          <li>
		  
            <p>
              <TextField
                name="tx_agency"
               	onChange={this.myChangeHandlerPV(index)}
                fullWidth
                value={item.tx_agency}
                inputProps={{ tabIndex: "2", maxLength: 150 }}
                className="txtbox"
                InputLabelProps={{ shrink: true }}
              />
            </p>
		  </li>
          <li>
            <p>
              <TextField
                name="dwt_percentage"
               	onChange={this.myChangeHandlerPV(index)}
                fullWidth
                value={item.dwt_percentage}
                inputProps={{ tabIndex: "3", maxLength: 150 }}
                className="txtbox"
                InputLabelProps={{ shrink: true }}
              />
            </p>
          </li>
        
      </ul>
	)}
    
  </React.Fragment>
))}
		</div> 
			 )}
  {this.state.combineclose===true  &&  (
		 <p className="greentextcolor" onClick={()=>{this.AddNewCombinecompoent()}}>Add Component</p>
			  )}




	
		{this.state.txmainid === "0" && (
		   <div className="combinedtxtbox">
	<b>Components</b>		
	{this.state.combinedata.map((item, index) => (
  
<React.Fragment	  key={index}>
 
	
     
	 <ul>
	  <li> </li>
	 <li className="graytxtcolor"> <span className="samllcircle"></span>{item.tx_name}</li>
	
	 <li> </li>
	 <li className="graytxtcolor">{item.dwt_percentage} </li>
	 
	 </ul>
	 
	
    
  </React.Fragment>
))}
		</div> 
		
		
		
		)}






	{this.state.txmainid!== 0 &&  (
 <div className="combinedtxtbox">
	{this.state.combinedata.map((item, index) => (
    <React.Fragment	  key={index}>
     {item.tx_isdeleted === "0" &&  item.tx_mainid!=="0" &&(
     
	 <ul>
	 <li>
	 <p>From<span className="validation">*</span></p>
	  <LocalizationProvider dateAdapter={AdapterDayjs}>
			<DemoContainer components={['DatePicker']}>
			<DatePicker
			    value={dayjs(item.fromdate)}
			  style={{ width: '50%' }}
			  onChange={(date) => this.fromDataHandler(date)}
			  format="MM/DD/YYYY"
			  className="txtbox"
			  disabled
			  	/>
		  </DemoContainer>
		</LocalizationProvider>
	
	 </li>
	 <li>
	 </li>
	 
	 
	 <li>
	 <p>Rate<span className="validation">*</span></p>
	  <p>
	  
	   <TextField
                name="dwt_percentage"
                 onChange={this.myChangeHandler}
                
                value={item.dwt_percentage}
                className="txtbox"
                disabled
              /></p>

	 </li>
	 
	 
	 </ul>
	
	)}
    
  </React.Fragment>
))}
		</div>
		)}		
		



		
	<div className="combinedtxtbox">
	{this.state.newRateArray.map((item, index) => (
    <React.Fragment	  key={index}>
     {item.tx_isdeleted=== "0" &&  item.tx_mainid!=="0" &&(
     
	 <ul>
	 <li>
	
	  <LocalizationProvider dateAdapter={AdapterDayjs}>
			<DemoContainer components={['DatePicker']}>
			<DatePicker
			    value={dayjs(item.fromdate)}
			  style={{ width: '50%' }}
			  onChange={(date) => this.fromDataHandler(date)}
			  format="MM/DD/YYYY"
			  className="txtbox"
			  	/>
		  </DemoContainer>
		</LocalizationProvider>
	
	 </li>
	 <li>
	 </li>
	 
	 
	 <li>
	 
	  <p>
	  
	   <TextField
                name="newpercentage"
                 onChange={this.myChangeHandler}
                
                value={item.newpercentage}
                className="txtbox"
                
              /></p>

	 </li>
	 
	 
	 </ul>
	 
	 
	 
	)}
    
  </React.Fragment>
))}
		</div>



		{this.state.txmainid!=="0" && this.state.txid!="0" && (
		 <p className="greentextcolor"  onClick={()=>{this.GetEmptyCombinecompoentRateandDate()}}>Update Rows</p>

		)}



			 
			
<Checkbox {...label} value={this.state.tx_visible}  checked={this.state.tx_visible }  onChange={this.handleshowcheck} color="default" /><b> Show this tax rate</b><p>Showing this tax rate will make it available for use throughout the application</p>



			 
			 
			 
          <div className="actionbtns">
	   <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.onclicktaxclose}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" disabled={this.state.btndisabled} className="frmSecondarybtn" onClick={this.handleSubmit}>
    {this.state.submitbtn}
</Button>
    </div>        


	
<div className="clear"></div>

 </div>     
        </DialogContent>
      </Dialog>
	  
	  
	</div>
    </React.Fragment>
  );
}
}